import React from "react";

interface SntTextProps {
  value?: React.ReactNode | unknown;
}

const SntText = ({ value }: SntTextProps) => {
  return <>{value === undefined || value === null ? "" : value}</>;
};
export default SntText;
